import * as React from 'react';
import { ForbiddenState } from '@app/components/ForbiddenState';
import { hasAnyRole } from '@app/utils/roles';

interface RequireRoleProps {
  /** Realm roles that may pass. Holding any one of them is enough. */
  roles: readonly string[];
  children: React.ReactNode;
}

/**
 * Renders its page only for a user holding one of `roles`, and ForbiddenState for everybody else.
 *
 * Applied by routes.tsx rather than by the pages themselves, so a route cannot be added to a
 * restricted group and quietly ship unguarded - see flattenRoutes, which wraps every element it
 * flattens with the roles its group declares. Hiding the navigation item is not enough on its
 * own: the address is still typed, bookmarked and pasted into chat.
 *
 * Not security. The token says what the user claims to be and the browser cannot check it, so
 * this only decides what is drawn; every endpoint behind these pages enforces the same role
 * itself. README-permissions.md lists which.
 */
const RequireRole: React.FunctionComponent<RequireRoleProps> = ({ roles, children }) =>
  hasAnyRole(roles) ? <>{children}</> : <ForbiddenState />;

export { RequireRole };
